import { z } from "zod";
import { sceneObjectTypeEnumSchema } from "../../enumSchemas";
import apiSceneObjectTypeDataSchema from "./apiSceneObjectTypeDataSchema";

const apiSceneObjectDataSchema = z.object({
    uuid: z.uuid(),
    type: sceneObjectTypeEnumSchema,
    data: z.string(),
    ownedBy: z.string().optional().nullable(),
    modifiedAt: z.string(),
    sceneObjectTypeData: apiSceneObjectTypeDataSchema.nullable().optional(),
  });

export default apiSceneObjectDataSchema;